import { TeamAdminViewDto } from '@act/shared/data-transfer-objects';
import {
  createEntityAdapter,
  createAction,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { teamsRequests } from 'redux/requests/teams.requests';
import { TeamState } from 'redux/types/teamsTypes';
import { createApiThunk } from 'redux/utils/api-thunk';
import { useAppSelector } from 'redux/store-hooks';

// THUNKS/ACTIONS ==============================================================

export const createTeam = createApiThunk(teamsRequests.createTeam);
export const updateTeam = createApiThunk(teamsRequests.updateTeam);
export const getTeamsAsAdmin = createApiThunk(teamsRequests.getTeamsAsAdmin);

export const updateTeamSuccess = createAction<TeamAdminViewDto>(
  'teams/updateTeamSuccess'
);
export const createTeamSuccess = createAction<TeamAdminViewDto>(
  'teams/createTeamSuccess'
);
// INITIAL STATE ===============================================================
const teamsEntityAdapter = createEntityAdapter<TeamAdminViewDto>();

const initialState: TeamState = {
  status: 'initial',
  team: teamsEntityAdapter.getInitialState(),
};

// SLICE =======================================================================
export const teamSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getTeamsAsAdmin.pending, state => {
        state.status = 'loading';
        teamsEntityAdapter.removeAll(state.team);
      })
      .addCase(getTeamsAsAdmin.fulfilled, (state, action) => {
        state.status = 'success';
        teamsEntityAdapter.setAll(state.team, action.payload);
      })
      .addCase(getTeamsAsAdmin.rejected, state => {
        state.status = 'failed';
      })
      .addCase(
        updateTeamSuccess,
        (state, action: PayloadAction<TeamAdminViewDto>) => {
          teamsEntityAdapter.upsertOne(state.team, action.payload);
          state.status = 'success';
        }
      )
      .addCase(
        createTeamSuccess,
        (state, action: PayloadAction<TeamAdminViewDto>) => {
          teamsEntityAdapter.upsertOne(state.team, action.payload);
          state.status = 'success';
        }
      );
  },
});

// REDUCER =====================================================================
export const teamsReducer = teamSlice.reducer;

// SELECTORS ===================================================================
const selectTeamsSliceState = state =>
  (state as { teams: typeof initialState })?.teams;

export const selectAllTeamsAsAdmin = createSelector(
  selectTeamsSliceState,
  teamState => teamState?.team
);

export const teamsSelectors = {
  useSelectAll: () => useAppSelector(selectAllTeamsAsAdmin),
};
